/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styles from './SetupContributionPage.css';
import Button from '../../components/Button/Button';
import WithMentionMe from '../../components/WithMentionMe/WithMentionMe';

import {
  contributionCompleteStepVisitedAction,
  ongoingContributionCompleteStepVisitedAction,
  returnLinkClickedAction,
  ongoingReturnLinkClickedAction,
  referFriendClickedAction,
  ongoingReferFriendClickedAction,
} from '../../redux/modules/contributions';
import { getIsCustomerOngoing } from '../../redux/selectors/experience';
import { setForceMentionMeModalAction } from '../../redux/modules/investmentAdvice';
import BaseGrid from '../../components/BaseGrid/BaseGrid';
import MentionMeTile from '../../components/MentionMeTile/MentionMeTile';

import TransferThankYouBg from '../../assets/images/transfer-thank-you-bg.svg';
import { SHOW_MENTION_ME } from '../../util/constants';

const ContributionCompleteStep = ({
  dispatchContributionCompleteStepVisited,
  dispatchReturnLinkClicked,
  dispatchReferFriendClicked,
  dispatchSetForceMentionMeModal,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatchContributionCompleteStepVisited();
  }, []);

  return (
    <BaseGrid pageSectionStyles={{ marginBottom: '200px' }} addPensionsTheme>
      <WithMentionMe>
        <div className={styles.contributionsContainer}>
          <div className={styles.imageContainer}>
            <img src={TransferThankYouBg} alt="Green tick" />
          </div>
          <h2 className={styles.contributionsHeading}>{'Your Direct Debit is being set up'}</h2>
          <h5 className={styles.contributionsSubHeading}>{'What happens next?'}</h5>
          <div className={styles.standardContainer}>
            <div className={styles.whatHappensNextRow}>
              <div className={styles.whatHappensNextNumber}>{'1'}</div>
              <p className={styles.whatHappensNextText}>{'We’ll instruct Aegon to create your regular contribution direct debit'}</p>
            </div>
            <div className={styles.whatHappensNextRow}>
              <div className={styles.whatHappensNextNumber}>{'2'}</div>
              <p className={styles.whatHappensNextText}>{'You’ll receive a secure message in your account once approved'}</p>
            </div>
            <div className={styles.whatHappensNextRow}>
              <div className={styles.whatHappensNextNumber}>{'3'}</div>
              <p className={styles.whatHappensNextText}>{'Monthly contributions will be taken from your account and invested into your personalised pension plan'}</p>
            </div>
          </div>
          <Button
            size="large"
            onClick={() => {
              dispatchSetForceMentionMeModal();
              dispatchReturnLinkClicked();
            }}
            to="/"
            label="Return to dashboard"
          />
        </div>
        {SHOW_MENTION_ME && (
          <div className={styles.mentionMeContainer}>
            <div className={styles.mentionMeCard}>
              <MentionMeTile />
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
              <div
                id="mmWrapper"
                className="setup-contribution-mm"
                onClick={() => dispatchReferFriendClicked()}
              />
            </div>
          </div>
        )}
      </WithMentionMe>
    </BaseGrid>
  );
};

const mapStateToProps = (state) => ({
  isCustomerOngoing: getIsCustomerOngoing(state),
});

const mapDispatchToProps = {
  _dispatchOnboardingContributionCompleteStepVisited: contributionCompleteStepVisitedAction,
  _dispatchOngoingContributionCompleteStepVisited: ongoingContributionCompleteStepVisitedAction,
  _dispatchOnboardingReturnLinkClicked: returnLinkClickedAction,
  _dispatchOngoingReturnLinkClicked: ongoingReturnLinkClickedAction,
  _dispatchOnboardingReferFriendClicked: referFriendClickedAction,
  _dispatchOngoingReferFriendClicked: ongoingReferFriendClickedAction,
  dispatchSetForceMentionMeModal: setForceMentionMeModalAction,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { isCustomerOngoing } = stateProps;
  const {
    _dispatchOnboardingContributionCompleteStepVisited,
    _dispatchOngoingContributionCompleteStepVisited,
    _dispatchOnboardingReturnLinkClicked,
    _dispatchOngoingReturnLinkClicked,
    _dispatchOnboardingReferFriendClicked,
    _dispatchOngoingReferFriendClicked,
  } = dispatchProps;
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    dispatchContributionCompleteStepVisited: isCustomerOngoing ? _dispatchOngoingContributionCompleteStepVisited : _dispatchOnboardingContributionCompleteStepVisited,
    dispatchReturnLinkClicked: isCustomerOngoing ? _dispatchOngoingReturnLinkClicked : _dispatchOnboardingReturnLinkClicked,
    dispatchReferFriendClicked: isCustomerOngoing ? _dispatchOngoingReferFriendClicked : _dispatchOnboardingReferFriendClicked,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ContributionCompleteStep);
